/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_Clearfilters1Inputs */

const en_btn_clearfilters1 = /** @type {(inputs: Btn_Clearfilters1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear Filters`)
};

/**
* | output |
* | --- |
* | "Clear Filters" |
*
* @param {Btn_Clearfilters1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const btn_clearfilters1 = /** @type {((inputs?: Btn_Clearfilters1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_Clearfilters1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_btn_clearfilters1(inputs)
});
export { btn_clearfilters1 as "btn_clearFilters" }